import React, { useEffect } from "react";

import { useFormik } from "formik";
import * as Yup from "yup";
import List_It_Logo from "../assets/image/ListIt.png";
import './Styles/Login.css'
import { ColorTheme } from "../../constant/ColorTheme";
import { NavigationRoutes } from "../../constant/Routes";
import { isAuthenticated } from "../../helpers/AdminAuthentication";
import { useNavigate } from "react-router-dom";
import { forgotPasswordRequest } from "../../redux/actionDispatcher/auth/forgotPassDispatcher";
import { connect } from "react-redux";
import LoaderButton from "../common/LoaderButton";


function ForgotPassword({forgotPassword,forgotPasswordRequest}) {

  const validationSchema = Yup.object({
    email: Yup.string().email("Invalid Email Format*").required("Please Enter Email"),
  });
  var navigate = useNavigate();
  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema,


    onSubmit: (values) => {
      // // console.log(values);
      const data = {
        email: formik.values.email,
      };
      console.log(data);

      //passing the data in fetchUsers which contain the dispatch method
      //Add new lines and response in fetchUsers function
      forgotPasswordRequest(data,navigate);
    },
  });
   useEffect(() => {
      if (isAuthenticated()) {
        navigate(NavigationRoutes.ADMIN_DASHBOARD);
      }
    }, [navigate]);

  return ( <>
   <div
          className="position-absolute top-50 start-50 translate-middle login-card "
        >

          <form onSubmit={formik.handleSubmit} className="login-form">
            <div className="d-flex justify-content-center mb-3">
              <img
                src={List_It_Logo}
                alt="logo list"
                height={80}
                style={{ alignItems: "center", }}
              />{" "}
              <br />
            </div>
            <div className="">
              <h4 className="h4 fw-bold" style={{ color: ColorTheme.colors.primary }}> <b> Forgot Password </b></h4>
              <p className="p mb-3 " style={{ color: "black" }}>  Please enter your registered email.  </p>
            </div>
            <div className="mb-3 input-login-box">
              <input
                value={formik.values.email}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                name="email"
                type="text"
                className="form-control login-input mb-2"
                placeholder="Email"
                disabled={forgotPassword.loading}
              />
              {formik.errors.email && formik.touched.email ? (
                <div className="text-danger fs-6 mb-2 ">{formik.errors.email}</div>
              ) : (
                ""
              )}
              
            </div>
          
          
            <button
              className="w-100 btn btn-md btn-warning fw-bold text-light button-color"
              type="submit"
              // disabled={forgotPassword.loading}
            >
              {/* used loader for button here ============= */}
              {
              forgotPassword.loading ? (<LoaderButton />) :
              
              "Submit"}
            </button>
            
          </form>
        </div>
  </>
    );
}

const mapStateToProps = (state) => {
  return {
    forgotPassword: state.forgotPassword,
  };
};

//passing the changePassword in fetchUsers function and also dispatch method
const mapDispatchToProps = (dispatch) => {
  return {
    forgotPasswordRequest: (data, navigate) => dispatch(forgotPasswordRequest(data, navigate)),
  };
};

//Connecting the component to our store
export default connect(mapStateToProps, mapDispatchToProps)(ForgotPassword);

